<template>
  <div class="picture-viewer">
    <!-- Main Picture -->
    <div>
      <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
        <swiper-slide v-for="(picture, index) in pictures" :key="index">
          <PictureFallback :picture="picture" />
          <div class="zoom d-none d-sm-block">
            <font-awesome-icon icon="search-plus"></font-awesome-icon>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <!-- Picture List -->
    <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
      <div class="p-2 mx-2 swiper-photo-button-next buttons-navigation circle-icon" slot="button-next">
        <font-awesome-icon icon="chevron-right"></font-awesome-icon>
      </div>
      <div class="p-2 mx-2 swiper-photo-button-prev buttons-navigation circle-icon" slot="button-prev">
        <font-awesome-icon icon="chevron-left"></font-awesome-icon>
      </div>
      <swiper-slide v-for="(picture, index) in pictures" :key="index">
        <PictureFallback :picture="picture" />
      </swiper-slide>
    </swiper>
    <!-- Image Modal -->
    <b-modal ref="imageModal" size="lg" hide-footer>
      <PictureFallback :picture="selectedPicture" />
    </b-modal>
  </div>
</template>


<script>
import PictureFallback from "@/components/PictureFallback";

export default {
  name: "picture-viewer",
  components: {
    PictureFallback,
  },
  props: {
    pictures: Array,
  },
  data() {
    return {
      swiperOptionTop: {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-photo-button-next",
          prevEl: ".swiper-photo-button-prev",
        },
      },
      swiperOptionThumbs: {
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
      selectedPicture: this.pictures[0],
      fallback: require("@/static/fallback_drug_picture.png"),
    };
  },
  mounted() {
    this.$nextTick(() => {
      // Link both swipers
      const swiperTop = this.$refs.swiperTop.swiper;
      const swiperThumbs = this.$refs.swiperThumbs.swiper;
      swiperTop.controller.control = swiperThumbs;
      swiperThumbs.controller.control = swiperTop;

      // Link with image modal
      swiperTop.on("tap", () => {
        this.selectedPicture = this.pictures[swiperTop.realIndex];
        this.$refs.imageModal.show();
      });
    });
  },
  methods: {
    imageLoadError(evt) {
      evt.srcElement.src = require("@/static/fallback_drug_picture.png");
    },
  },
};
</script>


<style lang="scss" scoped>
.swiper-slide {
  background-size: cover;
  background-position: center;
  border: 1px solid $grey4-color;
}

.gallery-top {
  height: 80% !important;
  width: 100%;
}

.gallery-top .swiper-slide {
  cursor: zoom-in;
  width: inherit !important;
}

.gallery-thumbs {
  height: 20% !important;
  box-sizing: border-box;
  padding: 10px 0;
}

.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}

.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}

.zoom {
  background-color: $corp-color2;
  color: white;
  font-size: 1.5rem;
  height: 2.8rem;
  margin-left: auto;
  margin-top: -2.8rem;
  padding-left: 0.7rem;
  padding-top: 0.4rem;
  position: relative;
  width: 2.8rem;
  z-index: 1;
}

.circle-icon {
  display: inline-block;
  border-radius: 1.8rem;
  width: 1.8rem;
  height: 1.8rem;
  text-align: center;
  vertical-align: middle;
  line-height: 0.2rem;
  box-shadow: 0px 0px 2px #888;
}

.swiper-photo-button-next {
  float: right;
}

.swiper-photo-button-prev {
  float: left;
}

.buttons-navigation {
  width: 2rem;
  z-index: 2;
  color: $gray-500;
  cursor: pointer;
  position: relative;
  margin-top: -4rem;
}
</style>
